import React, { useMemo, useEffect } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import TreeView from './Tree.js'
import redux from '../redux/index.js'
import { isSelected, sortFileItems, getSiteSuffix } from '../util.js'
import { makeSelectorUserdata } from '../redux/login/selectors.js'
import { styled } from '@pergas-common/pergas-components'

const TreeViewHolder = styled.div`
  display: flex;
  flex: 1;
  flex-grow: 1;
  flex-direction: column;
  padding-bottom: 50px;
  background: #fff;
`

const FolderView = ({
  strings,
  selected,
  selectedFolderNode,
  expand,
  items,
  siteUrl,
  documentData,
  onSetSelectedFolder,
  onGetRootFolder,
  onGetSubFolders,
  searchValue,
  searchResults,
  isSearching,
  showSearchResults,
  onSearchValueChange,
  onStartSearch,
  onResetSearch,
  branding,
  ...rest
}) => {
  const selectUserdata = useMemo(makeSelectorUserdata, [])
  const userdata = useSelector((state) => selectUserdata(state))
  const dispatch = useDispatch()
  const isProject = documentData.project?.id !== undefined

  const onSetSelectedItem = (e, folderItem) => {
    if (!userdata.sc_root) {
      return
    }
    if (folderItem.type === 'rootfolder') {
      onSetSelectedFolder(folderItem)
      onGetRootFolder(selected.currentFolder)
    } else if (folderItem.type === 'folder') {
      onSetSelectedFolder(folderItem)
      if (!expand[folderItem.id]) {
        onGetSubFolders(selected.currentFolder, folderItem)
      }
    }
  }
  console.info('FolderView render', documentData.project, documentData.contact)

  useEffect(() => {
    const siteSuffix = getSiteSuffix({
      pds_id: documentData.project?.id ?? documentData.contact?.id,
      pds_type: isProject ? 'project' : 'contact'
    })

    const headerName = isProject
      ? [documentData.contact?.name, documentData.project?.name].filter(Boolean).join(' - ')
      : documentData.contact?.name

    dispatch(redux.actions.folders.getSiteRootFolder(siteSuffix, headerName))
  }, [])

  return (
    <TreeViewHolder>
      {/* <SearchInput onSetSelectedItem={onSetSelectedItem} /> */}
      {showSearchResults
        ? (
          <TreeView
            type='folder'
            items={searchResults}
            expand={expand}
            sortItems={sortFileItems}
            isSelected={isSelected(selectedFolderNode)}
            onItemSelected={onSetSelectedItem}
            isProject={isProject}
            siteUrl={siteUrl}
            branding={branding}
          />
          )
        : (
          <TreeView
            type='folder'
            items={items}
            expand={expand}
            sortItems={sortFileItems}
            isSelected={isSelected(selectedFolderNode)}
            onItemSelected={onSetSelectedItem}
            isProject={isProject}
            siteUrl={siteUrl}
            branding={branding}
          />
          )}
    </TreeViewHolder>
  )
}

const mapStateToProps = (state) => {
  const {
    selectedFolderNode,
    trees,
    searchValue,
    searchResults,
    showSearchResults,
    isSearching
  } = state.folders

  const {
    documentData
  } = state.save

  const { userData } = state.login
  const branding = userData.tmSettings?.branding

  const getFolderMeta = (item) => {
    const DEFAULT = { expand: {}, items: [] }
    if (item) {
      return trees[`${item.type}:${item.id}`] || DEFAULT
    } else {
      return DEFAULT
    }
  }

  const { expand, items } = getFolderMeta(state.selected.currentFolder)
  return {
    strings: state.locale.strings,
    selectedFolderNode,
    selected: state.selected,
    expand,
    items,
    siteUrl: (documentData?.project?.url ?? documentData?.contact?.url) + '/files',

    documentData,

    searchValue,
    searchResults,
    showSearchResults,
    isSearching,

    branding
  }
}

const mapDispatchToProps = (dispatch) => {
  const { folders } = redux.actions

  return {
    onSetSelectedFolder: (folderItem) => {
      dispatch(folders.setSelectedFolder(folderItem))
    },
    onGetRootFolder: (siteItem) => {
      dispatch(folders.getRootFolder(siteItem))
    },
    onGetSubFolders: (siteItem, folderItem) => {
      dispatch(folders.getSubFolder(siteItem, folderItem))
    },
    onSearchValueChange: (value) => {
      dispatch(folders.setSearchValue(value))
    },
    onStartSearch: (current, searchValue) => {
      dispatch(folders.searchFolders(current, searchValue))
    },
    onResetSearch: () => {
      dispatch(folders.resetSearch())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FolderView)
